const MAX_EDGE = 1600
const KEEP_BELOW_BYTES = 600 * 1024
const JPEG_QUALITY = 0.82

/**
 * Уменьшает фотографию перед отправкой: снимки с телефона весят 3–6 МБ и на слабой мобильной сети не успевают
 * загрузиться за таймаут, из-за чего очередь копится. Длинная сторона — до 1600 px, JPEG ~0,82; ориентация из EXIF
 * учитывается. Если уменьшить не удалось или выигрыша нет, файл отправляется как есть.
 */
export async function compressPhoto(file: File): Promise<File> {
  if (!file.type.startsWith('image/') || file.type === 'image/gif' || file.size <= KEEP_BELOW_BYTES) return file
  if (typeof createImageBitmap !== 'function' || typeof document === 'undefined') return file
  let bitmap: ImageBitmap | null = null
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height))
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const context = canvas.getContext('2d')
    if (!context) return file
    context.drawImage(bitmap, 0, 0, width, height)
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY))
    if (!blob || blob.size === 0 || blob.size >= file.size) return file
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg', lastModified: file.lastModified })
  } catch {
    return file
  } finally {
    bitmap?.close()
  }
}
